export default "__VITE_ASSET__zgJaKq_V__"